<template>
    <div>

        <section v-if="starredItems.length" class="starred-items">
            <div class="container">

                <div v-if="starredItems.length" class="starred-items__header">
                    Your Starred Items
                </div>

                <div v-if="!starredItems.length" class="starred-items__header">
                    When you star an item it'll show up here. Great for Christmas lists!
                </div>

                <transition-group name="slide-fade" mode="out-in" tag="div" v-if="starredItems.length" class="row mb-3">
                    <product
                        v-for="(product, i) in starredItems"
                        :key="i"
                        :product="JSON.parse(product.data)"
                        :index="i + 1"
                        :selectedCurrency="selectedCurrency"
                    ></product>
                </transition-group>

            </div>
        </section>

        <section v-if="!starredItems.length" class="no-starred-products-found-section">
            <div class="container">
                <div class="row">
                    <div class="col-lg-12">
                        <div class="no-starred-products-found-wrapper">

                            <div class="no-starred-products-found-wrapper__icon">
                                Star
                            </div>

                            <div class="no-starred-products-found-wrapper__text">
                                When you star an item it will show up here. Great for Christmas lists!
                            </div>

                            <router-link :to="{name: 'home'}" class="btn btn-purple btn-block">Search</router-link>

                        </div>
                    </div>
                </div>
            </div>
        </section>

    </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    name: 'dashboard',
    data () {
        return {
        }
    },
    computed: {
        ...mapGetters({
            user: 'user/user',
            starredItems: 'products/starredItems',
            selectedCurrency: 'products/selectedCurrency'
        })
    },
    methods: {
    },
    async mounted () {
    },
    created () {
    },
    watch: {
    },
    validations: {
    }
}
</script>

<style lang="scss" scoped>
    @import '~@/assets/css/components/_variables.scss';

    .starred-items {
        padding: 45px 0;

        &__header {
            font-size: 1.2rem;
            font-weight: bold;
            margin-bottom: 20px;
        }
    }

    .no-starred-products-found-section {
        padding: 55px 0;

        .no-starred-products-found-wrapper {
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            justify-content: center;
            text-align: left;
            width: 100%;
            padding: 40px;
            background: $off-white;
            margin: 0 auto;

            @media (min-width: 992px) {
                width: 50%;
            }

            &__icon {
                font-size: 5rem;
                margin-bottom: 20px;
                margin-left: auto;
                margin-right: auto;
            }

            &__text {
                font-size: 1.1rem;
                margin-bottom: 30px;
                text-align: left;
            }
        }
    }

</style>
